import { Flex, Inline, xcss } from '@atlaskit/primitives';
import React from 'react';

const elementBeforeIconWrapper = xcss({
  marginInlineEnd: 'space.050'
});

/**
 * A shared component for context menu item leading icons.
 */
export const ElementBeforeIconWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Flex xcss={elementBeforeIconWrapper}>{children}</Flex>;
};

const elementAfterShortCutWrapper = xcss({
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  borderRadius: 'radius.small',
  paddingInline: 'space.050',
  font: 'font.body.small',
  alignSelf: 'flex-end'
});

/**
 * A shared component for the context menu items with fixed styles.
 */
export const ElementAfterShortCutWrapper = ({
  tooltip
}: {
  tooltip: React.ReactNode | undefined;
}) => {
  return <Inline xcss={elementAfterShortCutWrapper}>{tooltip}</Inline>;
};
